import { createContext, useContext } from 'react';
import type { PlanEntitlements } from '@/lib/billing/plan-entitlements';

export type BooleanFeature =
  | 'bulkUpload'
  | 'analytics'
  | 'leadManagement'
  | 'aiConversations'
  | 'customDomain';

export type CountFeature = 'imagesPerProduct' | 'productUploads';

export interface PlanUpgradePrompt {
  title: string;
  description: string;
}

export interface PlanGateContextValue {
  isReady: boolean;
  entitlements: PlanEntitlements;
  allowsFeature: (feature: BooleanFeature) => boolean;
  allowsCount: (feature: CountFeature, nextCount: number) => boolean;
  openUpgradeModal: (prompt?: PlanUpgradePrompt) => void;
}

export const fallbackEntitlements: PlanEntitlements = {
  maxProducts: Number.POSITIVE_INFINITY,
  maxImagesPerProduct: Number.POSITIVE_INFINITY,
  maxAiConversationsPerMonth: Number.POSITIVE_INFINITY,
  bulkUpload: true,
  analytics: 'advanced',
  leadManagement: true,
  customDomain: true,
  staffAccounts: true,
  apiAccess: true,
};

export const PlanGateContext = createContext<PlanGateContextValue>({
  isReady: true,
  entitlements: fallbackEntitlements,
  allowsFeature: () => true,
  allowsCount: () => true,
  openUpgradeModal: () => undefined,
});

export function usePlanGate() {
  return useContext(PlanGateContext);
}
